// src/js/actions/index.js
import { USER_LOGIN} from "../constants/action-types";
export const userLogin = userInfo => ({ type: USER_LOGIN, payload: userInfo });
